import { render, staticRenderFns } from "./Coincidencias.vue?vue&type=template&id=7269a982"
import script from "./Coincidencias.vue?vue&type=script&lang=js"
export * from "./Coincidencias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports